import { isPlainObject } from 'lodash';
import { filterResolverKey as RESOLVER_KEY } from '@wix/wix-data-client-common-standalone';
const RESOLVER_VALUE = 'userInput';
export const addUserInputResolver = (filterExpression) => Object.assign({}, filterExpression, { [RESOLVER_KEY]: RESOLVER_VALUE });
export const shouldResolveUserInput = (filterExpression) => isPlainObject(filterExpression) &&
    filterExpression[RESOLVER_KEY] === RESOLVER_VALUE;
//# sourceMappingURL=userInputFilterResolver.js.map